
define('text!editor/edit/map/index.html',[],function () { return '<div id="mapbox-map"></div>';});

